/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const PAPERCLIP_VIEWBOX = 11;

const PAPERCLIP_PATH =
  'M9.62498 5.72912L5.49998 9.85412C4.51343 10.8407 2.91153 10.8407 1.92498 9.85412C0.938429 8.86757 0.938429 7.26567 1.92498 6.27912L6.04998 2.15412C6.72477 1.61541 7.6966 1.66972 8.30715 2.28028C8.91771 2.89084 8.97203 3.86266 8.43331 4.53746L4.35414 8.66246C4.14127 8.87533 3.83101 8.95846 3.54022 8.88055C3.24943 8.80263 3.0223 8.5755 2.94439 8.28471C2.86647 7.99393 2.94961 7.68366 3.16248 7.47079L6.82914 3.80412';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Paperclip / attachment (11×11). Color via `stroke` or CSS `color` + `currentColor`.
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const PaperclipIcon = ({
  size = 11,
  stroke = 'currentColor',
  strokeWidth = 0.916667,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${PAPERCLIP_VIEWBOX} ${PAPERCLIP_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={PAPERCLIP_PATH} stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" />
  </svg>
);

PaperclipIcon.propTypes = {
  ...iconPropTypes,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

export { PaperclipIcon };
export default PaperclipIcon;
